module.exports = __webpack_public_path__ + "img/status-change.bd9e4db6.png";